/*
 * $Id:: index.js 2020/11/11 12:46 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import React, { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

import { GLOBALS_SLICE_NAME } from '../../../app/constants';
import { SLICE_NAME as AUTH_SLICE_NAME } from '../../AuthenticatedPage/constants';
import { stringUrlToObject } from '../../../common/utils';
import { t } from '../../../providers';
import AuthContainer from '../../AuthenticatedPage/components/AuthContainer';
import LoginPageComponent from '../components';
import EpaslaugosLoginComponent from '../../AuthenticatedPage/components/EpaslaugosLoginComponent';
import { SLICE_NAME } from '../constants';
import helpers from '../SSOHelpers';
import { error as loginError, loading as loginLoading, response as responseSlice } from '../ssoSlice';

const SSOLoginPage = () => {
    const history = useHistory();
    const loading = useSelector(loginLoading);
    const error = useSelector(loginError);
    const response = useSelector(responseSlice);

    const { search } = useLocation();
    const dispatch = useDispatch();

    const [challenge, setLoginChallenge] = useState('');

    useEffect(() => {
        const searchObj = stringUrlToObject(search);

        if (error !== 'account.not.verified') {
            if (!searchObj || !searchObj.login_challenge) {
                dispatch({ type: `${SLICE_NAME}/error`, payload: null });
                dispatch({ type: `${GLOBALS_SLICE_NAME}/globalLoading`, payload: true });
                helpers.triggerAuth();
            } else {
                if (searchObj.error) {
                    dispatch({ type: `${SLICE_NAME}/error`, payload: searchObj.error });
                } else {
                    dispatch({ type: `${SLICE_NAME}/error`, payload: null });
                    dispatch({ type: `${GLOBALS_SLICE_NAME}/globalLoading`, payload: false });
                    setLoginChallenge(searchObj.login_challenge);
                }
            }
        }
        if (searchObj && searchObj.errorMessageKey === 'account.not.verified') {
            dispatch({ type: `${AUTH_SLICE_NAME}/credentials`, payload: { username: searchObj.username, challenge: searchObj.login_challenge } });
            history.push('/registration/verify');
        }
    }, [dispatch, search]);

    useEffect(() => {
        const navigateToVerifyAccount = () => {
            if (error === 'account.not.verified') {
                dispatch({ type: `${SLICE_NAME}/error`, payload: null });
                history.push('/registration/verify');
            }
        };
        navigateToVerifyAccount();
    }, [error, dispatch, history]);

    useEffect(() => {
        if (response && response.fromAction === 'LOGIN_SUCCESS') {
            dispatch({ type: `${SLICE_NAME}/response`, payload: null });
            dispatch({ type: `${GLOBALS_SLICE_NAME}/globalLoading`, payload: true });
            helpers.verifyLoginToSSO(response.redirect);
        }
    }, [response, dispatch]);

    const navigateToResetAccount = (event) => {
        event.preventDefault();
        dispatch({ type: `${SLICE_NAME}/error`, payload: null });
        history.push('/forgotten-login');
    };

    const login = (data) => {
        dispatch({ type: `${SLICE_NAME}/login`, payload: { ...data, challenge } });
    };

    return (
        <AuthContainer preTitle={'1'} title={t('please.add.your.information.to.login')}>
            <LoginPageComponent login={login} navigateToResetAccount={navigateToResetAccount} error={error} loading={loading || !challenge} />
            <EpaslaugosLoginComponent />
        </AuthContainer>
    );
};

export default SSOLoginPage;
